import { Paper, Typography } from "@mui/material";

export default function Description(props) {
  return (
    <Paper sx={{ p: 2, display: "flex", flexDirection: "column" }}>
      <Typography variant="h6" color="primary" gutterBottom>
        Scraped Description
      </Typography>
      <Typography>{props.estatedProperty.scraper.description}</Typography>
    </Paper>
  );
}
